<template>
  <v-snackbar v-model="show" bottom left :timeout="timeout" :color="color">
    <v-icon color="white" v-if="color === 'success'">check_circle</v-icon>
    <v-icon color="white" v-if="color === 'info'">info</v-icon>
    <v-icon color="white" v-if="color === 'warning'">warning</v-icon>
    <v-icon color="white" v-if="color === 'error'">error</v-icon>
    <span class="ml-5">{{ message }}</span>
    <v-spacer />
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      color: "",
      timeout: 5000
    };
  },
  created: function() {
    this.$store.watch(
      state => state.snackbar.snackNotif,
      () => {
        const message = this.$store.state.snackbar.snackNotif.message;
        if (message) {
          this.show = true;
          this.message = message;
          this.type = this.$store.state.snackbar.snackNotif.type ?? this.type;
          this.timeout =
            this.$store.state.snackbar.snackNotif.timeout ?? this.timeout;
          this.color = this.$store.state.snackbar.snackNotif.color;
          this.$store.commit("snackbar/setSnackNotif", {});
        }
      }
    );
  }
};
</script>
